import React from 'react';  
import './index.css';
import { Tabs,WingBlank,WhiteSpace } from 'antd-mobile';
import TabMember from '../tabMember'
 
import Comment from '../comment'
import {
  connect
} from 'react-redux';
import {
  actionCreators
} from 'courseLiveInfoStore';
import Bottom  from '../interlocutionBottom';
import { StickyContainer, Sticky } from 'react-sticky';

import userRequest from 'common/request'

import VideoModal from '../videoModal'
import moment from 'moment';

function renderTabBar(props) {
  return (<Sticky>
    {({ style }) => <div style={{ ...style, zIndex: 20,top:'45px' }}><Tabs.DefaultTabBar {...props} /></div>}
  </Sticky>);
}


 
class InfoTab extends React.Component{
  state={
    onLinePeople: 0,
    visible: false,
    isFirst: true
  }
  componentWillMount () {
    // this.getOnLine()  暂时不获取真实在线人数
    // this.getTestOnLine(this.props.liveinfo.course_info.structure_id || 0)
  }
  getTestOnLine = (num) => {
    if (this.state.isFirst&&this.props.liveinfo.live.maxlinkpeople && num > this.props.liveinfo.live.maxlinkpeople) {
        this.props.liveingHandle(false) // 超出上限不请求流地址
        this.setState({visible: true})
    }
    
    // if ( num < 50){//[0,50) ==> 如果获取的人数小于50,展示人数为 rand(5,20) +num
    //   num = Math.ceil(Math.random()*15) + 5 + num
    // } else if ( num < 300 ){//[50,300) ==>如果获取的人数小于300,展示人数为 rand(50,200) +num
    //   num = Math.ceil(Math.random()*50) + 150 + num
    // } else if ( num < 1000 ){//[300,1000) ==> 如果获取的人数小于1000,展示人数为 rand(100,300) +num
    //   num = Math.ceil(Math.random()*100) + 200 + num
    // } else {// [1000, -)如果获取的人数大于1000,展示人数为 rand(300,500) +num
    //   num = Math.ceil(Math.random()*200) + 300 + num
    // }
    this.setState({onLinePeople: num, isFirst: false})
  }
  getTabs(){
    let tabs =[
      {title: `讨论区(${this.numberHandle(this.state.onLinePeople)})`},
      // {title: '在线学员('+(this.state.onLinePeople || 0)+')'}
      ]
    
    return tabs
  }
  onClose = () => {
    this.setState({visible: false})
    window.history.back()
  }
  getOnLine = () => {
    var _this = this;
    return new Promise((resolve, reject) => {
      const liveinfo = this.props.liveinfo
      const roomid = liveinfo.live.room_id
      userRequest.get(`${window.AppConfig.websocketHTTP}/online/room`, {
        type: 'live', 
        rooms: roomid,
        _t: moment().format('x'),
      }).then(res => {
        if (!res.data) return
        if (_this.state.isFirst&&liveinfo.live.maxlinkpeople && res.data[roomid] >= liveinfo.live.maxlinkpeople) {
          this.props.liveingHandle(false) // 超出上限不请求流地址
          this.setState({visible: true})
        }
        const peopleNum = this.numberHandle(res.data[roomid])
        _this.setState({onLinePeople: peopleNum, isFirst: false})
        resolve(res.data[roomid])
      })
    })
  }
  numberHandle = (num) => {
    if (num > 9999) return `${(num/10000).toFixed(1)}万人`
    else return `${num}人`
  }
 
  render(){
    const { userinfo, liveinfo,memberlist} =this.props;
    const {tabs}=this.state
    const roomid = liveinfo.live.room_id
    return (
      <div className="info-tab">
        <StickyContainer> 
          <Tabs  
            tabs={this.getTabs()} 
            animated={false}
            initalPage={'t2'}
            swipeable={false}
            renderTabBar={renderTabBar}>
            <div className="tab-main">
            <WhiteSpace/>
              { 
                roomid&&userinfo.get('user_name')
                ?
                <Comment roomid={roomid} getOnLine={this.getOnLine} getTestOnLine={this.getTestOnLine} onLinePeople={this.state.onLinePeople}/> 
                :
                <WingBlank>
                  <p style={{textAlign:'center'}}>无房间号</p>
                </WingBlank>
              } 
            </div>
            <div className="tab-main">
              {/*<TabMember/>*/}
            </div>  
          </Tabs>
        </StickyContainer>
        <VideoModal visible={this.state.visible} onClose={this.onClose}/>
      </div>
      )
  }
}
 
const mapState = (state) => ({ 
  userinfo:state.getIn(['home','userinfo']),
  memberlist:state.getIn(['courseliveinfo','memberlist']),
  chatList:state.getIn(['courseliveinfo','chatList']),
 })
 

const mapDispatch = (dispatch) => ({
 
  
})
export default connect(mapState, mapDispatch)(InfoTab);